module.exports = __webpack_public_path__ + "img/chess_chessblack4.8e164ab0.png";